import useSWR from 'swr';
import { fhirBaseUrl, openmrsFetch, restBaseUrl } from '@openmrs/esm-framework';
import type { OpenmrsEncounter } from '../types';
import { encounterRepresentation } from '../constants';

export function deleteEncounter(patientUuid: string, encounterUuid: string, abortController: AbortController) {
  return openmrsFetch(`${restBaseUrl}/encounter/${encounterUuid}`, {
    method: 'DELETE',
    signal: abortController.signal,
  });
}

export type Encounter = {
  id: string;
  display: string;
  encounterDatetime: string;
  provider: string;
  encounterType: string;
  location: string;
  lastUpdated: string;
};

type UseEncounters = {
  encounters: Array<OpenmrsEncounter>;
  isError: Error | null;
  isLoading: boolean;
  isValidating: boolean;
  mutate: () => void;
};

export function useEncounters(patientUuid: string, encounterType): UseEncounters {
  const encountersUrl = `${restBaseUrl}/encounter?patient=${patientUuid}&encounterType=${encounterType}&v=${encounterRepresentation}`;

  const { data, error, isLoading, isValidating, mutate } = useSWR<
    { data: { results: Array<OpenmrsEncounter> } },
    Error
  >(patientUuid ? encountersUrl : null, openmrsFetch);

  return {
    encounters: data ? data?.data.results : [],
    isError: error,
    isLoading,
    isValidating,
    mutate,
  };
}

function mapEncounterProperties(encounter: any): Encounter {
  return {
    id: encounter?.uuid,
    display: encounter?.display,
    encounterDatetime: encounter?.encounterDatetime,
    provider: encounter?.provider?.display,
    encounterType: encounter?.encounterType?.display,
    location: encounter?.location?.display,
    lastUpdated: encounter?.auditInfo?.dateChanged || encounter?.auditInfo?.dateCreated,
  };
}
